// extracted by mini-css-extract-plugin
module.exports = {"icon":"ProfilePaymentHistory_icon__1qCj6"};